/**
 * 智慧无限 DK87 Fn 层虚拟键盘展示（对齐华奋达 X87 V2 策略）：
 * - 有 Fn 功能映射的格：显示功能名/图标码
 * - 无映射的格：回退普通层物理键帽（F1–F12、字母等）
 */

import {
  isZhwxFnDisplayKeyCode,
  isZhwxFnLayerSupported,
} from "@eweadn-qiankun/shared-utils";

export type ZhwxSdkRowLayout = {
  layer: number;
  row: number;
  keyboardLayout: number[];
};

/** Fn 层行数据与普通层合并，空槽或未改键格保留基础层键名 */
export function applyZhwxDk87FnLayerToSdkRows(
  fnRows: ZhwxSdkRowLayout[],
  baseRows?: ZhwxSdkRowLayout[] | null
): ZhwxSdkRowLayout[] {
  if (!baseRows?.length) return fnRows;
  return fnRows.map((fnRow) => {
    const baseRow = baseRows.find((item) => item.row === fnRow.row);
    if (!baseRow?.keyboardLayout?.length) return fnRow;
    const merged = fnRow.keyboardLayout.map((fnCode, col) => {
      const baseCode = baseRow.keyboardLayout[col] ?? 0;
      if (!fnCode) return baseCode;
      if (isZhwxFnDisplayKeyCode(fnCode)) return fnCode;
      if (fnCode === baseCode) return baseCode;
      return fnCode;
    });
    return { ...fnRow, keyboardLayout: merged };
  });
}

export function shouldApplyZhwxDk87FnLayer(
  keyboardType: string,
  layer: number,
  solutionRovider?: string | null
): boolean {
  return (
    layer !== 0 &&
    isZhwxFnLayerSupported(keyboardType) &&
    String(solutionRovider ?? "") === "ZHWX"
  );
}
